var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.508,
    height: 24.501,
    viewBox: "0 0 21.508 24.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Switch_arrows",
    "data-name": "Switch arrows",
    transform: "translate(-1414.024 -342.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M397.412,558.779c-.4-.39-.812-.77-1.2-1.171q-2.38-2.45-4.75-4.91a.915.915,0,0,1-.008-1.465q2.795-2.892,5.591-5.781a.832.832,0,0,1,1.446.3.918.918,0,0,1-.272.963q-2.006,2.064-4,4.135a1.759,1.759,0,0,1-.2.158l.044.072h16.962a1.968,1.968,0,0,1,.393.029.849.849,0,0,1,.666.939.838.838,0,0,1-.785.777c-.1.006-.194,0-.291,0H394.06l-.086.117a.984.984,0,0,1,.252.14c1.306,1.344,2.59,2.711,3.92,4.028a.954.954,0,0,1-.257,1.664Z",
    transform: "translate(1023.188 -191.78)",
    fill: "#14305c",
    stroke: "#14305c",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M405.832,347.981a8.706,8.706,0,0,1,.678.577q2.671,2.748,5.331,5.509a.916.916,0,0,1,0,1.465q-2.776,2.872-5.551,5.745a.867.867,0,0,1-.952.3.881.881,0,0,1-.315-1.46c.549-.579,1.108-1.149,1.663-1.722q1.2-1.237,2.395-2.473a1.568,1.568,0,0,1,.209-.156l-.042-.079h-.3q-8.342,0-16.684-.006a1.444,1.444,0,0,1-.631-.139.831.831,0,0,1-.394-.954.841.841,0,0,1,.761-.648c.1-.007.194,0,.291,0H409.3c-.091-.1-.149-.173-.212-.238l-3.87-4c-.666-.689-.627-1.168.14-1.708Z",
    transform: "translate(1023.073 -4.98)",
    fill: "#14305c",
    stroke: "#14305c",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.ed97ba0aa2c1c25acd1bb06df5c96762.svg";
export { ForwardRef as ReactComponent };